import React from 'react';
import './Instruction.css';
import ReviewFormattedMessage from './ReviewFormattedMessage';

export default function Instruction({instructions}){
    return(   
        <div className="Instruction-instruction">
            {
              instructions.map((inst, index) => {
                return <p key={index}><ReviewFormattedMessage descriptor={inst.instruction}/></p> 
              })
            } 
        </div>  
    )
}